import { type DocumentViewerSend, type DocumentViewerSourceDefinition } from '../document-viewer-types'
import { type PDFPageStructure, type ResolvedPageStructure } from '../models'
import { MuPDFPageSurface } from './mupdf'
import { PDFDocumentRenderer } from './pdf-document-renderer'
export type { PDFSourceInput } from './pdf-source-input'

export function createPDFPageRenderSourceDefinition(): DocumentViewerSourceDefinition {
  return {
    rendererTag: PDFDocumentRenderer
  }
}

export function PDFPageSurface({
  send,
  pageStructure
}: {
  send: DocumentViewerSend
  pageStructure: ResolvedPageStructure
}) {
  return (
    <MuPDFPageSurface
      send={send}
      pageStructure={pageStructure as PDFPageStructure}
    />
  )
}
